import ReactDOM from "react-dom/client";
import React from "react";
import App from "./App";
import About from "./Pages/About";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import Contact from "./Pages/Contact";
import ProjectsMain from "./Pages/ProjectsMain";
import Resume from "./Pages/Resume";
import "bootstrap/dist/css/bootstrap.min.css";
import AnimatedCursor from "react-animated-cursor";

const router = createBrowserRouter([
  {
    path: "/",
    element: <App />,
  },
  {
    path: "App",
    element: <App />,
  },
  {
    path: "Contact",
    element: <Contact />,
  },
  {
    path: "About",
    element: <About />,
  },
  {
    path: "Projects",
    element: <ProjectsMain />,
  },
  {
    path: "Resume",
    element: <Resume />,
  },
]);
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <>
    <RouterProvider router={router} />

    {
      <div className="cursor">
        <AnimatedCursor
          innerSize={8}
          outerSize={35}
          innerScale={1}
          outerScale={2}
          outerAlpha={0}
          hasBlendMode={true}
          innerStyle={{
            backgroundColor: "white",
          }}
          outerStyle={{
            border: "3px solid white",
          }}
        />
      </div>
    }
  </>
);
